import { inferPriceSource } from "./infer-price-source";

import type { DailyRateCell, DailyRateCellStatus, PlanRoomDailyRateRow } from "./types";

export type RateMatrixRowSource = {
	id: string;
	planID: string;
	planName: string;
	isSCConnected: boolean;
	isDayTrip: boolean;
	roomID: string;
	roomName: string;
	isDummyRoom: boolean;
	salePeriodLabel: string;
	dailyCells: Array<{
		date: string;
		guestCells: Array<{
			adultNum: number;
			cell: {
				status: string;
				priceYen?: number | null;
				displayLabel?: string | null;
			};
		}>;
	}>;
};

const toDailyRateCell = (cell: RateMatrixRowSource["dailyCells"][number]["guestCells"][number]["cell"]): DailyRateCell => ({
	status: cell.status as DailyRateCellStatus,
	priceYen: cell.priceYen ?? null,
	displayLabel: cell.displayLabel ?? null,
});

/**
 * Query.rateMatrix の 1 行を画面の行型へ写す。料金計算はしない。
 * 行見出しは API の planName を正とする。
 *
 * adultNum 指定時は API が guestCells を 1 件だけ返す。表示人数で引くため requestedAdultNum を正とする。
 */
export const convertRateMatrixRow = (
	row: RateMatrixRowSource,
	requestedAdultNum: number,
): PlanRoomDailyRateRow => {
	const cellsByDate: PlanRoomDailyRateRow["cellsByDate"] = {};

	for (const dailyCell of row.dailyCells) {
		const guestCells: Partial<Record<number, DailyRateCell>> = {};
		const isSingleGuestCell = dailyCell.guestCells.length === 1;
		for (const guestCell of dailyCell.guestCells) {
			const adultKey = isSingleGuestCell ? requestedAdultNum : guestCell.adultNum;
			guestCells[adultKey] = toDailyRateCell(guestCell.cell);
		}
		cellsByDate[dailyCell.date] = guestCells;
	}

	return {
		id: row.id,
		planID: row.planID,
		planName: row.planName,
		isSCConnected: row.isSCConnected,
		isDayTrip: row.isDayTrip,
		roomID: row.roomID,
		roomName: row.roomName,
		isDummyRoom: row.isDummyRoom,
		priceSource: inferPriceSource(row),
		salePeriodLabel: row.salePeriodLabel,
		cellsByDate,
	};
};
